var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationjobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5.83073C11.6667 8.74331 8.43558 11.7766 7.35058 12.7135C7.2495 12.7895 7.12646 12.8306 6.99999 12.8306C6.87353 12.8306 6.75049 12.7895 6.64941 12.7135C5.56441 11.7766 2.33333 8.74331 2.33333 5.83073C2.33333 4.59305 2.82499 3.40607 3.70016 2.5309C4.57533 1.65573 5.76232 1.16406 6.99999 1.16406C8.23767 1.16406 9.42466 1.65573 10.2998 2.5309C11.175 3.40607 11.6667 4.59305 11.6667 5.83073Z",
    stroke: "#65748B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.58594C7.9665 7.58594 8.75 6.80244 8.75 5.83594C8.75 4.86944 7.9665 4.08594 7 4.08594C6.0335 4.08594 5.25 4.86944 5.25 5.83594C5.25 6.80244 6.0335 7.58594 7 7.58594Z",
    stroke: "#65748B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationjobs);
export default __webpack_public_path__ + "static/media/location jobs.64745e9dbacb4dc57c57a625b3a8adbf.svg";
export { ForwardRef as ReactComponent };